<template>
  <span
    v-tooltip="{ content: daysToDeadline <= 3 ? dueAtFormatted : null }"
    :class="{ fade: !dueAt, 'text--error': daysToDeadline <= 3 }"
    >{{ dueAt }}</span
  >
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: [Date, String],
    task: Object,
  },
  computed: {
    dueAtFormatted() {
      if (!this.value) return
      return moment(this.value).format('LL')
    },
    dueAt() {
      if (!this.value || this.task.status === 'done') return
      if (this.daysToDeadline >= 5) return this.dueAtFormatted
      return moment(this.value).endOf('day').from(moment())
    },
    daysToDeadline() {
      if (!this.value) return
      return moment(this.value).endOf('day').diff(moment().startOf('day'), 'days')
    },
  },
}
</script>

<style lang="scss"></style>
